export { _ as Kalendar, p as default } from './index-478f7fa6.js';
import 'vue';



//////////////////
// WEBPACK FOOTER
// ./~/kalendar-vue/dist/index.js
// module id = 311
// module chunks = 2